import { getStorageEntity } from '../storage';
import { IStorageEntity } from "../storage/interface";

export const LANG_KEY: string = 'lang';

export const langStorageEntity: IStorageEntity = getStorageEntity(LANG_KEY);